import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import UserSaga from "./Users/saga"
import PermissionSaga from "./Permissions/saga"
import Roles from "./Roles/saga"
import CustomerSaga from "./Customers/saga"
import LevelSaga from "./Levels/saga";
import RewardSaga from "./Rewards/saga"
import CourseSaga from "./Courses/saga"
import ModuleSaga from "./Modules/saga"
import ChapterSaga from "./chapters/saga"
import StudentSaga from "./Students/saga"
import TutorSaga from "./Tutors/saga"
import lessonSaga from "./lessons/saga"
import attendanceSaga from "./attendance/saga"
import assignmentSaga from "./assignment/saga"
import questionAndAnswersSaga from "./questionAndAnswers/saga"

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    UserSaga(),
    PermissionSaga(),
    Roles(),
    CustomerSaga(),
    LevelSaga(),
    RewardSaga(),
   fork(CourseSaga), 
    ModuleSaga(),
    ChapterSaga(),
    attendanceSaga(),
    assignmentSaga(),
    StudentSaga(),
    TutorSaga(),
     fork(lessonSaga),
     questionAndAnswersSaga()
  ])
}
